export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;